import React from 'react';

import Swatch from '../../../atoms/Swatch/Swatch';

const SwatchList = (props) => {

  const {label, swatchList, handleVariantChange, variantSpecs, id, styles} = props;
  const variant = variantSpecs?.find((tempVariant) => tempVariant.option_id === id);

  return (
    <div className={`${styles.optionList} ${styles.swatchList}`}>
      <span className={styles.label}>{label}: <strong>{variant?.label}</strong></span>
      <div className={styles.swatchSelection}>
        {swatchList?.map((colorChoice, index) => {          
            return(
                <Swatch
                    key={index} 
                    data={colorChoice} 
                    setActiveSwatch={(tempVariant) => handleVariantChange(tempVariant)}
                    isActive={variant?.id === colorChoice?.id}
                />
            ) 
        })}
      </div>
    </div>
  );
};

export default SwatchList;
